import React from "react";
import ServicesCard from "../cards/ServicesCard";

//  Style \\
import "../../assets/styles/sections/serviceshero.scss";

const ServicesHero = () => {
  return (
    <section className="services">
      <div className="services_bg">
        <div className="container">
          <div className="services_items">
            <div className="services_items_titles">
              <p>Home / Services</p>
              <h2>Our Services</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
